var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#E1EBF6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3359_3123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3359_3123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.25 16H26.425C26.2509 15.1536 25.7904 14.393 25.1209 13.8465C24.4515 13.3001 23.6142 13.0011 22.75 13L21.25 13C20.3858 13.0011 19.5485 13.3001 18.8791 13.8465C18.2096 14.393 17.7491 15.1536 17.575 16H16.75C15.7558 16.0012 14.8027 16.3967 14.0997 17.0997C13.3967 17.8027 13.0012 18.7558 13 19.75V27.25C13.0012 28.2442 13.3967 29.1973 14.0997 29.9003C14.8027 30.6033 15.7558 30.9988 16.75 31H27.25C28.2442 30.9988 29.1973 30.6033 29.9003 29.9003C30.6033 29.1973 30.9988 28.2442 31 27.25V19.75C30.9988 18.7558 30.6033 17.8027 29.9003 17.0997C29.1973 16.3967 28.2442 16.0012 27.25 16ZM21.25 14.5H22.75C23.2137 14.5019 23.6655 14.6471 24.0435 14.9156C24.4216 15.1841 24.7074 15.5628 24.862 16H19.138C19.2926 15.5628 19.5784 15.1841 19.9565 14.9156C20.3345 14.6471 20.7863 14.5019 21.25 14.5ZM16.75 17.5H27.25C27.8467 17.5 28.419 17.7371 28.841 18.159C29.2629 18.581 29.5 19.1533 29.5 19.75V22H14.5V19.75C14.5 19.1533 14.7371 18.581 15.159 18.159C15.581 17.7371 16.1533 17.5 16.75 17.5ZM27.25 29.5H16.75C16.1533 29.5 15.581 29.2629 15.159 28.841C14.7371 28.419 14.5 27.8467 14.5 27.25V23.5H21.25V24.25C21.25 24.4489 21.329 24.6397 21.4697 24.7803C21.6103 24.921 21.8011 25 22 25C22.1989 25 22.3897 24.921 22.5303 24.7803C22.671 24.6397 22.75 24.4489 22.75 24.25V23.5H29.5V27.25C29.5 27.8467 29.2629 28.419 28.841 28.841C28.419 29.2629 27.8467 29.5 27.25 29.5Z",
    fill: "#323232"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3359_3123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 13)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3359_3123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/CompanyIcon.e5b1a3b3dd2b49e2cae5116e435ff7f1.svg";
export { ForwardRef as ReactComponent };